module.exports = __webpack_public_path__ + "img/portal-generator-hero.cae41379.svg";